import styled from 'styled-components';
import WithDirection from '../../../config/withDirection';

const StyleWrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;

    .header-avatar { padding: 0 14px; }

    .nav-bars { margin-left: 14px; }
    .nav-bars span {
        display: block;
        margin-top: 3px;
        margin-bottom: 6px;
        height: 2px;
        width: 26px;
        background-color: #fff;
    }

    nav {
        position: absolute;
        top: 100%; right: -14px;
        display: none;
        padding-top: 11px;
        z-index: 2;
    }
    :focus nav,
    :hover nav { display: block; }

    nav ul {
        display: flex;
        flex-direction: column;
        border: 2px solid rgba(12, 183, 148, 1);
        background-color: rgba(35, 31, 32, 1);
        box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, .3);
    }
    nav li {
        min-width: 175px;
        padding: 10px 35px;
        text-transform: uppercase;
        text-align: center;
        white-space: nowrap;
        cursor: pointer;
        transition: .3s;
    }
    nav li:hover { background-color: #fff; color: rgba(35, 31, 32, 1); }

    :after {
        position: absolute;
        top: 90%;
        right: 0;
        left: 0;
        height: 100%;
        display: none;
        content: '';
        background-color: transparent;
        z-index: 1;
    }
    &:hover:after { display: inline-block; }

    @media screen and (max-width: 767px) {
        .header-avatar { display: none; }    
        .nav-bars { margin-left: 7px; }
    }

    @media screen and (min-width: 768px) and (max-width: 991px) {
        .header-avatar { padding: 0 7px; }
    }
`;
export default WithDirection(StyleWrapper);


// WEBPACK FOOTER //
// ./src/components/Headers/Menu/Wrapper.js